// import React from 'react';
// import { Trash2, Loader2 } from 'lucide-react';

// const BulkDeleteModal = ({ isOpen, onClose, onConfirm, selectedIds, users, isDeleting, progress }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 bg-black/60 backdrop-blur-sm" onClick={!isDeleting && onClose}>
//       <div className="w-full border sm:max-w-md bg-richblue-950 border-red-700/50 rounded-2xl sm:mb-0 mb-[170px]" onClick={(e) => e.stopPropagation()}>
//         <div className="flex justify-center pt-3 pb-1 sm:hidden">
//           <div className="w-10 h-1 bg-gray-600 rounded-full" />
//         </div>
//         <div className="p-5 space-y-4 sm:p-6">
//           <div className="flex items-start gap-3">
//             <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full bg-red-600/20">
//               <Trash2 className="w-5 h-5 text-red-400" />
//             </div>
//             <div>
//               <h3 className="text-base font-bold text-white">
//                 Delete {selectedIds.length} User{selectedIds.length > 1 ? 's' : ''}?
//               </h3>
//               <p className="mt-1 text-sm text-gray-400">
//                 This will permanently delete {selectedIds.length === 1 ? 'the selected user' : `all ${selectedIds.length} selected users`}. 
//                 This action cannot be undone.
//               </p>
//             </div>
//           </div>

//           <div className="p-3 space-y-1 overflow-y-auto border rounded-lg max-h-32 border-red-800/30 bg-red-900/10">
//             {selectedIds.map(id => {
//               const u = users?.find(u => u._id === id);
//               return u ? (
//                 <div key={id} className="flex items-center gap-2 text-sm">
//                   <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-[10px] font-bold text-white">
//                     {u.user_name?.charAt(0)}
//                   </div>
//                   <span className="text-white truncate">{u.user_name}</span>
//                   <span className="flex-shrink-0 ml-auto text-xs text-blue-400/50">{u.user_roll}</span>
//                 </div>
//               ) : null;
//             })}
//           </div>

//           {isDeleting && (
//             <div className="space-y-2">
//               <div className="flex justify-between text-xs text-blue-300">
//                 <span>Deleting users...</span>
//                 <span>{progress.current} / {progress.total}</span>
//               </div>
//               <div className="w-full h-2 rounded-full bg-richblue-900">
//                 <div
//                   className="h-2 transition-all duration-300 bg-red-600 rounded-full"
//                   style={{ width: `${progress.total > 0 ? (progress.current / progress.total) * 100 : 0}%` }}
//                 />
//               </div>
//             </div>
//           )}

//           <div className="flex gap-3 pb-2 sm:pb-0">
//             <button
//               type="button"
//               onClick={onClose}
//               disabled={isDeleting}
//               className="flex-1 py-2.5 text-sm font-medium text-blue-300 border rounded-lg border-blue-800/60 hover:bg-blue-800/20 transition-colors disabled:opacity-50"
//             >
//               Cancel
//             </button>
//             <button
//               type="button"
//               onClick={onConfirm}
//               disabled={isDeleting}
//               className="flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {isDeleting ? (
//                 <>
//                   <Loader2 className="w-4 h-4 animate-spin" /> Deleting...
//                 </>
//               ) : (
//                 <>
//                   <Trash2 className="w-4 h-4" /> Delete {selectedIds.length} User{selectedIds.length > 1 ? 's' : ''}
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BulkDeleteModal;



import React from 'react';
import { Trash2, Loader2 } from 'lucide-react';

const BulkDeleteModal = ({ isOpen, onClose, onConfirm, selectedIds, users, isDeleting, progress, theme }) => {
  if (!isOpen) return null;

  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgModal = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgRedIcon = isDark ? 'bg-red-600/20' : 'bg-red-100';
  const bgPreview = isDark ? 'bg-red-900/10' : 'bg-red-50';
  const bgProgress = isDark ? 'bg-richblue-900' : 'bg-gray-200';
  
  const borderColor = isDark ? 'border-red-700/50' : 'border-red-300';
  const borderPreview = isDark ? 'border-red-800/30' : 'border-red-200';
  //const borderCancel = isDark ? 'border-blue-800/60' : 'border-gray-300';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  const textSecondary = isDark ? 'text-gray-400' : 'text-gray-600';
  const textRed = isDark ? 'text-red-400' : 'text-red-600';
  //const textBlue = isDark ? 'text-blue-300' : 'text-blue-600';
  const textMuted = isDark ? 'text-blue-400/50' : 'text-gray-400';
  
  //const hoverBg = isDark ? 'hover:bg-blue-800/20' : 'hover:bg-gray-100';
  const buttonCancel = isDark
    ? 'text-blue-300 border-blue-800/60 hover:bg-blue-800/20'
    : 'text-gray-700 border-gray-300 hover:bg-gray-100';
  const buttonDelete = isDark
    ? 'bg-red-600 hover:bg-red-500'
    : 'bg-red-500 hover:bg-red-600';
  
  const progressBarBg = isDark ? 'bg-red-600' : 'bg-red-500';
  const dividerColor = isDark ? 'bg-gray-600' : 'bg-gray-300';

  return (
    <div className={`fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 ${isDark ? 'bg-black/60' : 'bg-gray-500/30'} backdrop-blur-sm`} onClick={!isDeleting && onClose}>
      <div className={`w-full border sm:max-w-md ${bgModal} ${borderColor} rounded-2xl sm:mb-0 mb-[170px] transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-center pt-3 pb-1 sm:hidden">
          <div className={`w-10 h-1 ${dividerColor} rounded-full`} />
        </div>
        <div className="p-5 space-y-4 sm:p-6">
          <div className="flex items-start gap-3">
            <div className={`flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full ${bgRedIcon} transition-colors duration-300`}>
              <Trash2 className={`w-5 h-5 ${textRed}`} />
            </div>
            <div>
              <h3 className={`text-base font-bold ${textPrimary}`}>
                Delete {selectedIds.length} User{selectedIds.length > 1 ? 's' : ''}?
              </h3>
              <p className={`mt-1 text-sm ${textSecondary}`}>
                This will permanently delete {selectedIds.length === 1 ? 'the selected user' : `all ${selectedIds.length} selected users`}. 
                This action cannot be undone.
              </p>
            </div>
          </div>

          <div className={`p-3 space-y-1 overflow-y-auto border rounded-lg max-h-32 ${bgPreview} ${borderPreview} transition-colors duration-300`}>
            {selectedIds.map(id => {
              const u = users?.find(u => u._id === id);
              return u ? (
                <div key={id} className="flex items-center gap-2 text-sm">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-[10px] font-bold text-white">
                    {u.user_name?.charAt(0)}
                  </div>
                  <span className={`${textPrimary} truncate`}>{u.user_name}</span>
                  <span className={`flex-shrink-0 ml-auto text-xs ${textMuted}`}>{u.user_roll}</span>
                </div>
              ) : null;
            })}
          </div>

          {isDeleting && (
            <div className="space-y-2">
              <div className={`flex justify-between text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'}`}>
                <span>Deleting users...</span>
                <span>{progress.current} / {progress.total}</span>
              </div>
              <div className={`w-full h-2 rounded-full ${bgProgress}`}>
                <div
                  className={`h-2 transition-all duration-300 ${progressBarBg} rounded-full`}
                  style={{ width: `${progress.total > 0 ? (progress.current / progress.total) * 100 : 0}%` }}
                />
              </div>
            </div>
          )}

          <div className="flex gap-3 pb-2 sm:pb-0">
            <button
              type="button"
              onClick={onClose}
              disabled={isDeleting}
              className={`flex-1 py-2.5 text-sm font-medium border rounded-lg ${buttonCancel} transition-colors disabled:opacity-50`}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isDeleting}
              className={`flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold text-white rounded-lg ${buttonDelete} transition-colors disabled:opacity-50 disabled:cursor-not-allowed`}
            >
              {isDeleting ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" /> Deleting...
                </>
              ) : (
                <>
                  <Trash2 className="w-4 h-4" /> Delete {selectedIds.length} User{selectedIds.length > 1 ? 's' : ''}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkDeleteModal;
